import { repository, cancelToken, baseURL } from '@/api/base'

let cancel = null

export default {
  async getCatalog() {
    const { data } = await repository.get(baseURL + '/employee/findAll')
    return data
  },

  async findByName(name) {
    cancel && cancel()

    const { data } = await repository.get(baseURL + '/employee/findAllByName?name=' + name, {
      cancelToken: new cancelToken(c => (cancel = c))
    })
    return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/employee', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/employee', body)
    return data
  },

  async changeInfo(body) {
    const { data } = await repository.put(baseURL + '/employee/changeInfo', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/employee/' + id)
  },

  async getCurrent() {
    const { data } = await repository.get(baseURL + '/employee/current')
    return data
  },

  async findAllByFilters(page, body) {
    cancel && cancel()

    const { data } = await repository.post(baseURL + `/employee/findAllByFilters/${page}`, body, {
      cancelToken: new cancelToken(c => (cancel = c))
    })
    return data
  }
}
